import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { AiImageUpscalerPage } from './pages/AiImageUpscalerPage';
import { AiImageEnlargerPage } from './pages/AiImageEnlargerPage';
import { FreeImageUpscalerPage } from './pages/FreeImageUpscalerPage';
import { ImageUpscaler4kPage } from './pages/ImageUpscaler4kPage';
import { EnlargePhotoOnlinePage } from './pages/EnlargePhotoOnlinePage';
import { EnlargeWithoutLosingQualityPage } from './pages/EnlargeWithoutLosingQualityPage';
import { PricingPage } from './pages/PricingPage';
import { FaqPage } from './pages/FaqPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ContactPage } from './pages/ContactPage';
import { NotFoundPage } from './pages/NotFoundPage';

export default function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/ai-image-upscaler" element={<AiImageUpscalerPage />} />
          <Route path="/ai-image-enlarger" element={<AiImageEnlargerPage />} />
          <Route path="/free-image-upscaler" element={<FreeImageUpscalerPage />} />
          <Route path="/image-upscaler-4k" element={<ImageUpscaler4kPage />} />
          <Route path="/enlarge-photo-online" element={<EnlargePhotoOnlinePage />} />
          <Route path="/enlarge-image-without-losing-quality" element={<EnlargeWithoutLosingQualityPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Route>
      </Routes>
    </HelmetProvider>
  );
}
